// source: proto/services/benchmark_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var proto_messages_benchmarks_pb = require('../../proto/messages/benchmarks_pb.js');
goog.object.extend(proto, proto_messages_benchmarks_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.proto.services.CreateBenchmarkRequest', null, global);
goog.exportSymbol('proto.proto.services.GetBenchmarksRequest', null, global);
goog.exportSymbol('proto.proto.services.GetBenchmarksResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.services.CreateBenchmarkRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.services.CreateBenchmarkRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.services.CreateBenchmarkRequest.displayName = 'proto.proto.services.CreateBenchmarkRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.services.GetBenchmarksRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.services.GetBenchmarksRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.services.GetBenchmarksRequest.displayName = 'proto.proto.services.GetBenchmarksRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.services.GetBenchmarksResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.services.GetBenchmarksResponse.repeatedFields_, null);
};
goog.inherits(proto.proto.services.GetBenchmarksResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.services.GetBenchmarksResponse.displayName = 'proto.proto.services.GetBenchmarksResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.services.CreateBenchmarkRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.services.CreateBenchmarkRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.services.CreateBenchmarkRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.services.CreateBenchmarkRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    benchmark: (f = msg.getBenchmark()) && proto_messages_benchmarks_pb.Benchmark.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.services.CreateBenchmarkRequest}
 */
proto.proto.services.CreateBenchmarkRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.services.CreateBenchmarkRequest;
  return proto.proto.services.CreateBenchmarkRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.services.CreateBenchmarkRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.services.CreateBenchmarkRequest}
 */
proto.proto.services.CreateBenchmarkRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_messages_benchmarks_pb.Benchmark;
      reader.readMessage(value,proto_messages_benchmarks_pb.Benchmark.deserializeBinaryFromReader);
      msg.setBenchmark(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.services.CreateBenchmarkRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.services.CreateBenchmarkRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.services.CreateBenchmarkRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.services.CreateBenchmarkRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBenchmark();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_messages_benchmarks_pb.Benchmark.serializeBinaryToWriter
    );
  }
};


/**
 * optional proto.messages.Benchmark benchmark = 1;
 * @return {?proto.proto.messages.Benchmark}
 */
proto.proto.services.CreateBenchmarkRequest.prototype.getBenchmark = function() {
  return /** @type{?proto.proto.messages.Benchmark} */ (
    jspb.Message.getWrapperField(this, proto_messages_benchmarks_pb.Benchmark, 1));
};


/**
 * @param {?proto.proto.messages.Benchmark|undefined} value
 * @return {!proto.proto.services.CreateBenchmarkRequest} returns this
*/
proto.proto.services.CreateBenchmarkRequest.prototype.setBenchmark = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.services.CreateBenchmarkRequest} returns this
 */
proto.proto.services.CreateBenchmarkRequest.prototype.clearBenchmark = function() {
  return this.setBenchmark(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.services.CreateBenchmarkRequest.prototype.hasBenchmark = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.services.GetBenchmarksRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.services.GetBenchmarksRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.services.GetBenchmarksRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.services.GetBenchmarksRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    tool: (f = msg.getTool()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    release: (f = msg.getRelease()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    testcase: (f = msg.getTestcase()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.services.GetBenchmarksRequest}
 */
proto.proto.services.GetBenchmarksRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.services.GetBenchmarksRequest;
  return proto.proto.services.GetBenchmarksRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.services.GetBenchmarksRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.services.GetBenchmarksRequest}
 */
proto.proto.services.GetBenchmarksRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTool(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setRelease(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTestcase(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.services.GetBenchmarksRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.services.GetBenchmarksRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.services.GetBenchmarksRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.services.GetBenchmarksRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTool();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getRelease();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTestcase();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue tool = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.proto.services.GetBenchmarksRequest.prototype.getTool = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.proto.services.GetBenchmarksRequest} returns this
*/
proto.proto.services.GetBenchmarksRequest.prototype.setTool = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.services.GetBenchmarksRequest} returns this
 */
proto.proto.services.GetBenchmarksRequest.prototype.clearTool = function() {
  return this.setTool(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.services.GetBenchmarksRequest.prototype.hasTool = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue release = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.proto.services.GetBenchmarksRequest.prototype.getRelease = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.proto.services.GetBenchmarksRequest} returns this
*/
proto.proto.services.GetBenchmarksRequest.prototype.setRelease = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.services.GetBenchmarksRequest} returns this
 */
proto.proto.services.GetBenchmarksRequest.prototype.clearRelease = function() {
  return this.setRelease(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.services.GetBenchmarksRequest.prototype.hasRelease = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue testcase = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.proto.services.GetBenchmarksRequest.prototype.getTestcase = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.proto.services.GetBenchmarksRequest} returns this
*/
proto.proto.services.GetBenchmarksRequest.prototype.setTestcase = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.services.GetBenchmarksRequest} returns this
 */
proto.proto.services.GetBenchmarksRequest.prototype.clearTestcase = function() {
  return this.setTestcase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.services.GetBenchmarksRequest.prototype.hasTestcase = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.services.GetBenchmarksResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.services.GetBenchmarksResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.services.GetBenchmarksResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.services.GetBenchmarksResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.services.GetBenchmarksResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    benchmarksList: jspb.Message.toObjectList(msg.getBenchmarksList(),
    proto_messages_benchmarks_pb.Benchmark.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.services.GetBenchmarksResponse}
 */
proto.proto.services.GetBenchmarksResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.services.GetBenchmarksResponse;
  return proto.proto.services.GetBenchmarksResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.services.GetBenchmarksResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.services.GetBenchmarksResponse}
 */
proto.proto.services.GetBenchmarksResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_messages_benchmarks_pb.Benchmark;
      reader.readMessage(value,proto_messages_benchmarks_pb.Benchmark.deserializeBinaryFromReader);
      msg.addBenchmarks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.services.GetBenchmarksResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.services.GetBenchmarksResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.services.GetBenchmarksResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.services.GetBenchmarksResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBenchmarksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_messages_benchmarks_pb.Benchmark.serializeBinaryToWriter
    );
  }
};


/**
 * repeated proto.messages.Benchmark benchmarks = 1;
 * @return {!Array<!proto.proto.messages.Benchmark>}
 */
proto.proto.services.GetBenchmarksResponse.prototype.getBenchmarksList = function() {
  return /** @type{!Array<!proto.proto.messages.Benchmark>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_messages_benchmarks_pb.Benchmark, 1));
};


/**
 * @param {!Array<!proto.proto.messages.Benchmark>} value
 * @return {!proto.proto.services.GetBenchmarksResponse} returns this
*/
proto.proto.services.GetBenchmarksResponse.prototype.setBenchmarksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.messages.Benchmark=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.messages.Benchmark}
 */
proto.proto.services.GetBenchmarksResponse.prototype.addBenchmarks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.messages.Benchmark, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.services.GetBenchmarksResponse} returns this
 */
proto.proto.services.GetBenchmarksResponse.prototype.clearBenchmarksList = function() {
  return this.setBenchmarksList([]);
};


goog.object.extend(exports, proto.proto.services);
